import { render, staticRenderFns } from "./ImgSberPay.vue?vue&type=template&id=88e70736&scoped=true&"
import script from "./ImgSberPay.vue?vue&type=script&lang=js&"
export * from "./ImgSberPay.vue?vue&type=script&lang=js&"
import style0 from "./ImgSberPay.vue?vue&type=style&index=0&id=88e70736&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e70736",
  null
  
)

export default component.exports